module.exports = __webpack_public_path__ + "files/2fe19856d8ee45472bc456555de0d061.png";